import {Alert, Button} from "fearless-common-ui";
import React, {useEffect, useMemo, useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {useField} from "formik";
import * as yup from "yup";
import QuantitySelector from "../billing/QuantitySelector";
import {BackendForm} from "../forms";
import {backendEndpoints} from "../../libs/backendEndpoints";


function Form() {
  const [{ value }, { error }, { setValue }] = useField('quantity');
  const increase = () => {
    setValue(typeof value === 'number' ? Math.max(0, value + 1) : 1);
  };

  const decrease = () => {
    setValue(typeof value === 'number' ?  Math.max(0, value - 1) : 1);
  };

  return (
    <>
      <QuantitySelector value={value} increase={increase} decrease={decrease} />
      {error && <Alert>{error}</Alert>}
    </>
  );
}

/**
 * Change the number of seats of a team subscription.
 */
export default function ChangeNumberOfSeats({ subscriptionId, usedSeats, totalSeats, onSuccess }: {
  /** The Laravel subscriptions table ID */
  subscriptionId: number;
  /** The current used seats of the team subscription */
  usedSeats: number;
  /** The current total seats of the team subscription */
  totalSeats: number;
  onSuccess?: () => void;
}) {
  const [show, setShow] = useState(false);
  const timeout = useRef<NodeJS.Timeout>(null);
  const { initialValues, validationSchema } = useMemo(() => {
    return {
      initialValues: {
        quantity: totalSeats,
      },
      validationSchema: yup.object({
        quantity: yup.number()
          .min(usedSeats, `Must be higher than the current ${usedSeats} used seats `)
          .not([totalSeats], `The current number of seats is ${totalSeats}. Please select another number`),
      }),
    };
  }, [usedSeats, totalSeats]);

  useEffect(() => {
    return function cleanUpChangeNumberOfSeats() {
      if (timeout.current) clearTimeout(timeout.current);
    }
  }, []);

  const open = () => setShow(true);
  const hide = () => setShow(false);

  return (
    <>
      <Button variant="link" className="p-0 text-sm" onClick={open}>Change</Button>
      {show && (
        <Modal show size="sm" onHide={hide}>
          <Modal.Header closeButton>
            <Modal.Title>Change seats number</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            {totalSeats === -1 ? <Alert>You pay as you go, so your subscription will automatically adjust as you add or remove members.</Alert> : (
              <BackendForm
                initialValues={initialValues}
                targetMethod="POST"
                targetEndpoint={backendEndpoints.changeSeats(subscriptionId)}
                validationSchema={validationSchema}
                onSuccess={() => {
                  if (timeout.current) clearTimeout(timeout.current);
                  timeout.current = setTimeout(() => {
                    if (onSuccess) onSuccess();
                    hide();
                  }, 2000);
                }}
                showFooter={false}
              >
                <Form/>
                <BackendForm.Footer showError buttonText="Change seat number" className="mt-4" center marginTop={false}/>
                <small className="d-block neutral-600 text-xs line-height-1-0 my-4">
                  You will receive an updated invoice via mail
                </small>
              </BackendForm>
            )}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
